// Initialize AOS (Animate On Scroll)
AOS.init({
    duration: 800,
    easing: 'ease-out-cubic',
    once: true,
    offset: 50
});

// Ensure video plays on mobile (iOS fix)
var heroVideo = document.getElementById('heroVideo');
if (heroVideo) {
    heroVideo.play().catch(function() {
        document.addEventListener('touchstart', function playVideo() {
            heroVideo.play();
            document.removeEventListener('touchstart', playVideo);
        }, { once: true });
    });
}

// Navigation scroll effect
var nav = document.getElementById('nav');
window.addEventListener('scroll', function() {
    nav.classList.toggle('scrolled', window.scrollY > 100);
});

// Mobile nav toggle
document.getElementById('navToggle').addEventListener('click', function() {
    document.querySelector('.nav-links').classList.toggle('active');
});

// Video toggle
var videoIcon = document.getElementById('videoIcon');
var videoToggle = document.getElementById('videoToggle');
if (videoToggle && heroVideo) {
    videoToggle.addEventListener('click', function() {
        if (heroVideo.paused) {
            heroVideo.play();
            videoIcon.classList.replace('fa-play', 'fa-pause');
        } else {
            heroVideo.pause();
            videoIcon.classList.replace('fa-pause', 'fa-play');
        }
    });
}

// Smooth scroll for same-page anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
        document.querySelector('.nav-links').classList.remove('active');
    });
});

// Close mobile nav when clicking a link
document.querySelectorAll('.nav-links a').forEach(function(link) {
    link.addEventListener('click', function() {
        document.querySelector('.nav-links').classList.remove('active');
    });
});

// Contact form submission
var contactForm = document.getElementById('contactForm');
if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
        e.preventDefault();
        alert('Thanks for reaching out! We\'ll get back to you soon.');
        e.target.reset();
    });
}

// Counter Animation
var counters = document.querySelectorAll('.counter');
var speed = 100;

var animateCounter = function(counter) {
    var target = +counter.getAttribute('data-target');
    var increment = target / speed;
    var current = 0;

    var updateCount = function() {
        current += increment;
        if (current < target) {
            counter.innerText = Math.ceil(current);
            requestAnimationFrame(updateCount);
        } else {
            counter.innerText = target;
        }
    };
    updateCount();
};

// Intersection Observer to trigger counters when visible
if (counters.length > 0) {
    var counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                counterObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    counters.forEach(function(counter) {
        counterObserver.observe(counter);
    });
}
